export default {
  getAttachmentCategoryIndex(state) {
    return state.attachmentCategoryIndex
  }
}
